import React from "react";
import {AdminTable} from "../../layouts";
import {useSelector} from "react-redux";
import {user} from "@oncities/schemas";

export default function Users() {
	const _user = useSelector((state) => state.user);
	return <AdminTable entity="users" user={_user} schemaFn={user} />;
}
